import { Form, Input, Modal, Select } from "antd";
import React, { useState } from "react";
import {
  DELETION_REASON_OPTIONS,
  DeletionReason,
  DeletionReasonValue,
} from "src/constants/samples";

const { Option } = Select;
const { TextArea } = Input;

export interface DeletionReasonResult {
  deletionReason?: DeletionReasonValue;
  deletionReasonNote?: string;
}

interface DeleteCompanyModalProps {
  open: boolean;
  title: string;
  content?: string;
  onConfirm: (result: DeletionReasonResult) => void;
  onCancel: () => void;
}

const DeleteCompanyModal: React.FC<DeleteCompanyModalProps> = ({
  open,
  title,
  content,
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState<DeletionReasonValue | undefined>(undefined);
  const [note, setNote] = useState<string>("");

  const reset = () => {
    setReason(undefined);
    setNote("");
  };

  const handleOk = () => {
    // Only forward a note when the reason is OTHER otherwise leave it undefined
    onConfirm({
      deletionReason: reason,
      deletionReasonNote: reason === DeletionReason.OTHER ? note.trim() || undefined : undefined,
    });
    reset();
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  return (
    <Modal
      open={open}
      title={title}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Delete"
      okButtonProps={{ disabled: !reason }}
    >
      {content ? <p>{content}</p> : null}

      <Form layout="vertical" style={{ marginTop: "1rem" }}>
        <Form.Item label="Reason for deletion" required>
          <Select
            placeholder="Select a reason"
            value={reason}
            onChange={(value: DeletionReasonValue) => setReason(value)}
          >
            {DELETION_REASON_OPTIONS.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {reason === DeletionReason.OTHER ? (
          <Form.Item label="Details">
            <TextArea
              rows={3}
              value={note}
              maxLength={500}
              placeholder="Add a short note"
              onChange={(e) => setNote(e.target.value)}
            />
          </Form.Item>
        ) : null}
      </Form>
    </Modal>
  );
};

export default DeleteCompanyModal;
